<template>
  <div app-header :class="[theme, roll, scrolled]">
    <header>
      <div class="inner-wrap">
        <a @click="historyBack" class="back" v-if="isBack"><p class="ir">BACK</p></a>
        <locale-link to="/" class="logo" v-else><h1 class="ir">NEWTYPE</h1></locale-link>
        <div class="aside">
          <a class="search" @click="onSearch"></a>
          <a class="menu" @click="onMenu"></a>
        </div>
      </div>
    </header>
    <aside class="drawer" :class="{ on: menuOpen }">
      <div class="drawer-backdrop"></div>
      <div class="drawer-holder">
        <div class="logo"></div>
        <a class="close" @click="clickClose"></a>
        <nav class="drawer-menu">
          <locale-link to="/works">Works</locale-link>
          <locale-link to="/works/article/about">About</locale-link>
          <a href="https://newtype.careers.team/" target="_blank">Career</a>
<!--          <locale-link to="/works/article/career">Career</locale-link>-->
          <locale-link to="/works/article/contact">Contact</locale-link>
        </nav>
        <p class="copyright">@2008-2023 Newtype Imageworks.</p>
      </div>
    </aside>
  </div>
</template>

<script>
export default {
  name: 'AppHeader',
  data() {
    return {
      menuOpen: false,
      searchOpen: false,
    };
  },
  computed: {
    theme() {
      return this.$store.state.theme;
    },
    roll() {
      return this.$store.state.browser.scrollDirection === 'down' && 'roll';
    },
    scrolled() {
      return this.$store.state.browser.scrolled;
    },
    isBack() {
      return this.$route.path.includes('/works/article/');
    },
  },
  watch: {
    $route: 'reset',
  },
  mounted() {
    this.$root.$on('search', this.onSearch);
  },
  beforeDestroy() {
    this.$root.$off('search', this.onSearch);
  },
  methods: {
    historyBack() {
      this.$store.state.browser.isFirst ? this.localeLink('/') : this.$router.go(-1);
    },
    reset() {
      this.menuOpen = false;
      this.searchOpen = false;
      this.$scroll.release();
    },
    onMenu(){
      this.$scroll.freeze();
      this.menuOpen = true;
    },
    onSearch(){
      this.$store.commit('isFirst', false);
      this.$scroll.freeze();
      this.$scroll.scrollTo(0);
      this.$store.commit('searchMode', true);
    },
    clickClose(){
      this.$scroll.release();
      this.menuOpen = false;
    },
  },
};
</script>

<style lang="less">
@import "~@/less/proj.less";

[app-header] { .fix; .wf; z-index:49;
  .search & { .hide; }
  &.roll header { .t-y(-100%); }
  header { .rel; .bgc(#fff); .wf; .h(58); .t-y(0); transition: transform 0.6s ease;
    .dark & { .bgc(#111); }
    .transparent & { .bgc(transparent); }
    .inner-wrap { .rel; .pv(15); .hf; .-box; .space-m;
      > a { .block; .wh(48,28); .contain; .no-repeat;
        &.logo { .bg('/img/common/logo.png');
          .dark & { .bg('/img/common/logo-w.png'); }
        }
        &.back { .bg('/img/common/ico-back.svg'); .wh(28);
          .dark & { .bg('/img/common/ico-back-w.svg'); }
        }
      }
      .aside { .abs; .rt(20,15);
        a { .wh(28); .ml(20); .contain; .no-repeat; .ib; transition: opacity .3s ease;
          .no-touch &:hover{.o(0.6);}
          &.search { .bg('/img/common/ico-search.svg'); }
          &.menu { .bg('/img/common/ico-hambergur.svg'); }
        }
        .dark & a {
          &.search { .bg('/img/common/ico-search-w.svg'); }
          &.menu { .bg('/img/common/ico-hambergur-w.svg'); }
        }
      }
    }
  }
  .drawer { .abs; .lt; .wf;
    .drawer-backdrop { .abs; .lt(-100%,0); .wf; .fvh; background-color: rgba(99, 99, 103, 0.6); .o(0); pointer-events: none; transition: opacity 0.4s ease; }
    .drawer-holder { .abs; .rt; .wf; .max-w(270); .fvh; .t-x(100%); .bgc(#222); overflow-y:auto; .p(24,20); .-box; .c(#fff); transition: transform 0.4s ease;
      .close { .abs; .rt(20,15); .wh(28); .contain('/img/common/ico-close.svg');
        .no-touch &:hover { .o(0.6); }
      }
      .logo { .wh(118,24); .contain('/img/common/drawer-logo.svg'); }
      .drawer-menu { .mt(100);
        a { .block; .fs(20,1); .c(#b4b4b4);
          &.router-link-active { .c(#fff); }
        }
        a + a { .mt(40); }
      }
      .copyright { .abs; .lb(20,15); .fs(12,20); .c(#b4b4b4); }
    }
    &.on {
      .drawer-backdrop { .l(0); .o(1); pointer-events: auto; }
      .drawer-holder { .t-x(0); }
    }
  }
}
@media (min-width: @screen-tp-min) {
  [app-header] {
    .drawer .drawer-holder { .p(30); .max-w(420);
      .logo { .wh(177,36); }
      .drawer-menu { .mt(120); }
      .copyright { .lb(30,30); }
    }
  }
}
@media (min-width: @screen-dm-min) {
  [app-header] {
    header { .h(72);
      .inner-wrap { .pv(18); .space-d;
        > a {
          &.logo { .wh(60,35); }
          &.back { .wh(36); }
        }
        .aside { .rt(40,18);
          a { .wh(36); .ml(30); }
        }
      }
    }
    .drawer .drawer-holder { .p(40,50); .max-w(600);
      .close { .rt(40,18); .wh(36); }
      .drawer-menu {
        a { .fs(28,40); }
        a + a { .mt(48); }
      }
      .copyright { .lb(50,40); .fs(14,20); }
    }
  }
}
@media (min-width: @screen-dx-min) {
  [app-header] {
    .drawer .drawer-holder { .p(50,60); .max-w(800);
      .logo { .wh(235,48); }
      .drawer-menu { .mt(160);
        a { .fs(32,40); }
      }
      .copyright { .lb(60,50); .fs(16,20); }
    }
  }
}
</style>
